import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import TreatmentCreate from '../../../features/Treatments/TreatmentCreate';
import { getReferral, createTreatment, getDefaultTimeSlotsPackage, getSettings } from '../../../actions/entities';
import {
  ENABLE_MAPPING_OF_TEAMS,
  ENABLE_RECORDING_OF_WEEKLY_REQUESTED_DAYS,
} from '../../../settings/constants/appSettings';

const mapStateToProps = ({
  entities: { referrals, timeSlots, settings },
  uiElements: { selectors },
  global: {
    auth: { jwtToken },
  },
}) => {
  const { isFetching: referralFetching, referral } = referrals.previewed;
  const { isFetching: timeSlotsFetching, timeSlotPackage } = timeSlots.defaultPackage;
  return {
    isFetching: timeSlotsFetching || referralFetching,
    referral,
    timeSlotsPackage: timeSlotPackage,
    activities: selectors.activities && selectors.activities.options,
    jwtToken,
    enableRecordingOfWeeklyRequestedDays: settings.appSettings[ENABLE_RECORDING_OF_WEEKLY_REQUESTED_DAYS] === 'true',
    enableMappingOfTeams: settings.appSettings[ENABLE_MAPPING_OF_TEAMS] === 'true',
  };
};

const mapDispatchToProps = dispatch => ({
  navigate: url => dispatch(push(url)),
  goBack: () => dispatch(goBack()),
  getReferral: id => dispatch(getReferral(id)),
  getDefaultTimeSlotsPackage: () => dispatch(getDefaultTimeSlotsPackage()),
  createTreatment: async treatmentData => await dispatch(createTreatment(treatmentData)),
  getSettings: settingName => dispatch(getSettings(settingName)),
});

const TreatmentCreatePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TreatmentCreate);

export default TreatmentCreatePage;
